import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import compose from '../../helpers/compose';
import { inject, observer } from 'mobx-react';
import { UserStoreKC } from '../../stores/userStoreKC';
import * as routes from 'routes';
import { Permission } from 'helpers/permissions';

export interface Props {
  redirectTo?: string;
  permission?: Permission;
}

interface Stores {
  userStore: UserStoreKC;
}

type P = Props & RouteProps & Stores;

const RoleBasedRoute: React.FC<P> = ({
  redirectTo,
  userStore,
  permission,
  ...restRouteProps
}) => {
  if (
    !permission || userStore.checkPermissions(permission)
  ) {
    return <Route {...restRouteProps} />;
  } else {
    return <Redirect to={redirectTo || routes.HOME_PAGE} />;
  }
};

export default compose(inject('userStore'), observer)(RoleBasedRoute);
